import React from "react";
import UserStatus from '../Common/UserStatus';
import ProfileImage from '../Common/ProfileImage';
import { initialNameHandle } from "../../../Helpers/Chat/User";
import PropTypes from 'prop-types';

const ContactInfoCheckBox = (props = {}) => {
    const {
        image = "",
        thumbImage = "",
        token = "",
        userId = "",
        status = "",
        roster = {},
        emailId = "",
        userJid = "",
        updateJid = "",
        isBlocked = false,
        statusMsg = "",
        selectState = false,
        contactName = "",
        initialName = "",
        hideCheckbox,
        hightlightText = "",
        handleChange = () => { },//click
        popUpToggleAction = () => { },//click
    } = props;
    const iniTail = initialNameHandle(roster);
    return (
            <li className={isBlocked ? "chat-list-li Blocked bc-none" : "chat-list-li"} data-ld={updateJid}>
                <label htmlFor={updateJid} aria-label="contact info" onClick={hideCheckbox ? handleChange : null}>
                    {
                        <ProfileImage
                            chatType={'chat'}
                            userToken={token}
                            temporary={false}
                            imageToken={(thumbImage && thumbImage !== "") ? thumbImage : image}
                            emailId={emailId}
                            userId={userId}
                            name={iniTail}
                            initialName={initialName}
                        />
                    }
                    <div className="recentchats">
                        <div className="recent-username-block">
                            <div className="recent-username">
                                <div className="username">
                                    <h3 title={contactName}><span>{hightlightText}</span></h3>
                                </div>
                            </div>
                        </div>
                        <div className="recent-message-block">
                            <UserStatus status={statusMsg || status} userId={updateJid} />
                        </div>
                        {!hideCheckbox && <div className="checkbox">
                            <input
                                name="participants"
                                type="checkbox"
                                checked={selectState}
                                onChange={handleChange}
                                value={selectState}
                                id={updateJid}
                            />
                            <label htmlFor={updateJid} className="white-color-txt">.</label>
                        </div>
                        }
                    </div>
                    {isBlocked &&
                        <span
                            className="Unblock"
                            data-jest-id={"jestpopUpToggleAction"}
                            onClick={() => { popUpToggleAction(userJid, contactName) }}
                            onKeyDown={(e) => e.key === 'Enter' && popUpToggleAction(userJid, contactName)}
                            tabIndex="0"
                            role="button"
                        >
                            Unblock
                        </span>
                    }
                </label>
            </li>
    )
}
export default ContactInfoCheckBox;

ContactInfoCheckBox.propTypes = {
    image: PropTypes.string,
    thumbImage: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    status: PropTypes.string,
    roster: PropTypes.object,
    emailId: PropTypes.string,
    userJid: PropTypes.string,
    updateJid: PropTypes.string,
    isBlocked: PropTypes.bool,
    statusMsg: PropTypes.string,
    selectState: PropTypes.bool,
    contactName: PropTypes.string,
    initialName: PropTypes.string,
    hideCheckbox: PropTypes.bool,
    hightlightText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    handleChange: PropTypes.func,
    popUpToggleAction: PropTypes.func,
};